/**
 * HTD SweetAlert defaults — import once at app boot (main.tsx).
 * Per-call options still override (e.g. confirmButtonColor: '#d33').
 * customClass is deep-merged so partial overrides keep HTD button classes.
 */
import Swal from 'sweetalert2'

const HTD_CUSTOM_CLASS: Record<string, string> = {
  container: 'htd-swal-container',
  popup: 'htd-swal-popup',
  title: 'htd-swal-title',
  htmlContainer: 'htd-swal-html',
  actions: 'htd-swal-actions',
  confirmButton: 'htd-swal-confirm',
  cancelButton: 'htd-swal-cancel',
  denyButton: 'htd-swal-deny',
  validationMessage: 'htd-swal-validation',
}

const originalFire = Swal.fire.bind(Swal)

function withHtdDefaults(options: Record<string, unknown> = {}) {
  const incomingClass =
    options.customClass && typeof options.customClass === 'object'
      ? (options.customClass as Record<string, string>)
      : {}

  return {
    confirmButtonColor: 'var(--htd-primary)',
    cancelButtonColor: '#64748b',
    backdrop: 'rgba(2, 6, 23, 0.8)',
    ...options,
    customClass: { ...HTD_CUSTOM_CLASS, ...incomingClass },
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
Swal.fire = ((...args: any[]) => {
  if (typeof args[0] === 'string' || typeof args[0] === 'number') {
    return originalFire(
      withHtdDefaults({
        title: String(args[0]),
        html: args[1],
        icon: args[2],
      }) as never,
    )
  }
  return originalFire(withHtdDefaults(args[0] || {}) as never)
}) as typeof Swal.fire

export default Swal
